// extracted by mini-css-extract-plugin
export var contact = "Footer-module--contact--6e434";
export var container = "Footer-module--container--225ff";
export var copyright = "Footer-module--copyright--85ee7";
export var decor = "Footer-module--decor--a8eb0";
export var hamburger = "Footer-module--hamburger--f8960";
export var lastRow = "Footer-module--lastRow--ba0c2";
export var logo = "Footer-module--logo--e021c";
export var programs = "Footer-module--programs--fedef";
export var reactCalendarMonthViewDays = "Footer-module--react-calendar__month-view__days--d6fde";
export var reactCalendarTile = "Footer-module--react-calendar__tile--a2ee3";
export var reactCalendarTileActive = "Footer-module--react-calendar__tile--active--43595";
export var relativeWrapper = "Footer-module--relativeWrapper--7d65b";
export var row = "Footer-module--row--5ad16";
export var social = "Footer-module--social--482f5";
export var units = "Footer-module--units--dfe16";
export var wrapper = "Footer-module--wrapper--99767";